import React, {Component} from 'react';
import { bindActionCreators }  from 'redux';
import { connect }  from 'react-redux';
import { shouldComponentUpdate } from 'react-immutable-render-mixin';

import * as PopupActions from '../actions/popup_actions';
import * as DraftActions from '../actions/drafts_actions';


import Draft from '../components/Draft.jsx';

class DraftContainer extends Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = shouldComponentUpdate.bind(this);
    }

    handleRemoveCategory() {
        this.props.draftActions.deleteSingleCategory(this.props.draft.id);
    }

    handleRemoveAll() {
        this.props.draftActions.deleteCategoryWithDrafts(this.props.draft.id, this.props.draft.count)
    }

    handleEdit() {
        this.props.popupActions.setEditPopup(this.props.draft.id)
    }

    render() {
        return (
        <Draft {...this.props}
            onRemoveAll={::this.handleRemoveAll}
            onRemoveCategory={::this.handleRemoveCategory}
            onEdit={::this.handleEdit}/>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        popupActions: bindActionCreators(PopupActions, dispatch),
        draftActions: bindActionCreators(DraftActions, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(DraftContainer);


// WEBPACK FOOTER //
// ./src/_app/drafts/containers/DraftContainer.jsx